import { render } from "./ProductSearchShow.vue?vue&type=template&id=d7e3619a&scoped=true"
import script from "./ProductSearchShow.vue?vue&type=script&lang=js"
export * from "./ProductSearchShow.vue?vue&type=script&lang=js"

import "./ProductSearchShow.vue?vue&type=style&index=0&id=d7e3619a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7e3619a"],['__file',"src/views/h5/common/sys/miniProgram/setting/component/ProductSearchShow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d7e3619a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d7e3619a', __exports__)) {
    api.reload('d7e3619a', __exports__)
  }
  
  module.hot.accept("./ProductSearchShow.vue?vue&type=template&id=d7e3619a&scoped=true", () => {
    api.rerender('d7e3619a', render)
  })

}


export default __exports__